import React, { useState } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";

const EventTypesForm = ({ initialData, onSubmit, onCancel, buttonLoading }) => {
  const [data, setData] = useState(initialData);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setData({ ...data, title: e.target.value });
    if (error) setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!data.title || data.title.trim() === "") {
      setError("Title is required");
      return;
    }
    onSubmit({
      title: data.title,
      eventTypeId: data.eventTypeId,
    });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} maxWidth={400} mx="auto">
      <Typography
        variant="h6"
        fontWeight={600}
        color="text.secondary"
        mb={2}
        textAlign="center"
      >
        {initialData ? "Edit Event Type" : "Create Event Type"}
      </Typography>

      <TextField
        label="Title"
        placeholder="Enter title"
        value={data ? data.title : ""}
        onChange={handleChange}
        fullWidth
        size="small"
        error={!!error}
        helperText={error}
        required
      />

      <Box mt={3} display="flex" justifyContent="flex-end" gap={1.5}>
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={{ textTransform: "none", borderRadius: "8px" }}
        >
          Cancel
        </Button>

        <Button
          type="submit"
          variant="contained"
          loading={buttonLoading}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            backgroundColor: "rgb(35, 71, 159)",
          }}
        >
          {initialData ? "Update" : "Create"}
        </Button>
      </Box>
    </Box>
  );
};

export default EventTypesForm;
